// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1PyVB","title":"Header_title__3YKEh","side":"Header_side__6SbPo"};